export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q04_a.7e296b56.png";